export default __webpack_public_path__ + "static/appalachian-smash-banner-649628d4ea8101500f287c611c76f5d0.jpg";